import React from 'react'

import useDidMount from '@divvy-web/hooks.usedidmount'
import useNameFormatter from '@divvy-web/hooks.usenameformatter'
import { FormattedMessage, useIntl } from '@divvy-web/i18n'
import { BASIC_BUTTON_TYPE_OUTLINED } from '@divvy-web/skylab.basicbutton'
import TextLink from '@divvy-web/skylab.textlink'

import { LogoutButton } from '@sputnik/components'
import GoToDashboardButton from '@sputnik/components/GoToDashboardButton'
import MarketingContent, { MarketingQuote } from '@sputnik/components/MarketingContent'
import AfterSubmitInfoPageLayout from '@sputnik/pages/PostApplicationPages/AfterSubmitInfoPageLayout'
import { PRODUCT_CONST_STRINGS } from '@sputnik/resources/constants'
import { useWebTracking } from '@sputnik/tracking/WebTrackingContext'

const MigrationSuccess = () => {
  const [getClassName] = useNameFormatter('MigrationSuccess')
  const { formatMessage } = useIntl()
  const { track } = useWebTracking()

  useDidMount(() => {
    track('se_signup__application_migration_success__presented')
  })

  return (
    <AfterSubmitInfoPageLayout
      buttons={
        <>
          <GoToDashboardButton
            componentName={getClassName('')}
            onClick={() => {
              track('se_signup__application_migration_success_go_to_dashboard__fired')
            }}
          />
          <LogoutButton
            buttonType={BASIC_BUTTON_TYPE_OUTLINED}
            onClick={() => {
              track('se_signup__application_migration_success_logout__fired')
            }}
          />
        </>
      }
      imageName='post-application-info-page'
      infoContent={
        <FormattedMessage
          defaultMessage='You’ll hear from us soon via email on next steps. Until then, you can check the status of your application by logging back in at <link>apply.divvy.co</link>'
          id='sputnik.MigrationSuccess__0wLquI'
          values={{
            link: (chunks) => (
              <TextLink
                href='https://apply.divvy.co'
                target='_blank'
              >
                {chunks}
              </TextLink>
            ),
          }}
        />
      }
      marketing={
        <MarketingContent
          image={{
            alt: formatMessage({
              defaultMessage: 'coworkers in business attire smiling and cheersing with drinks',
              id: 'sputnik.MigrationSuccess__4VFaNh',
            }),
            src: 'https://app.divvy.co/assets/stock-photos/credit-application-migration-success.png',
            isRounded: true,
          }}
          pillText={
            <FormattedMessage
              defaultMessage='Testimonial'
              id='sputnik.MigrationSuccess__MvBefC'
            />
          }
        >
          <MarketingQuote
            designation={
              <FormattedMessage
                defaultMessage='Senior accountant, PEAR Accounting'
                id='sputnik.MigrationSuccess__R7D/wB'
              />
            }
            name={
              <FormattedMessage
                defaultMessage='Shabbir Ambaliyasana'
                id='sputnik.MigrationSuccess__SZFzOu'
              />
            }
            quote={
              <FormattedMessage
                defaultMessage='“<strong>I am saving around 50 to 60 hours per month</strong> while using {BILL_SPEND_AND_EXPENSE}. It allowed me to spend this time to grow the business.”'
                id='sputnik.MigrationSuccess__8CfLdK'
                values={{
                  BILL_SPEND_AND_EXPENSE: PRODUCT_CONST_STRINGS.BILL_SPEND_AND_EXPENSE,
                  strong: (chunks) => <b>{chunks}</b>,
                }}
              />
            }
          />
        </MarketingContent>
      }
      title={
        <FormattedMessage
          defaultMessage='Your application has been submitted!'
          id='sputnik.MigrationSuccess__334LMo'
        />
      }
    />
  )
}

export default MigrationSuccess
